import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Quote, BookOpen, Calendar, Shield, Activity, RotateCw, FileText } from 'lucide-react';
export function ProofSection() {
  const quotes = ["Turns don't scare me like they did.", 'I feel calmer walking through my house.', "I'm not grabbing furniture as much.", 'My legs feel more reliable.', 'If I wobble, I know exactly what to do.'];
  const contents = [{
    icon: Shield,
    title: 'Safety Setup',
    desc: "your home 'no-surprise' rules (so you feel secure)"
  }, {
    icon: BookOpen,
    title: 'Drill Library',
    desc: 'chair-supported balance drills (clear, simple, repeatable)'
  }, {
    icon: Calendar,
    title: '14-Day Calendar',
    desc: 'tells you exactly what to do every day'
  }, {
    icon: RotateCw,
    title: 'Turning & Reaching training',
    desc: 'where most near-falls happen'
  }, {
    icon: Activity,
    title: 'Wobble Recovery Script',
    desc: "what to do in the moment (so fear doesn't take over)"
  }, {
    icon: FileText,
    title: 'Maintenance Plan',
    desc: '3 days/week to keep results'
  }];
  return <section className="w-full px-4 py-12 max-w-2xl mx-auto" data-id="element-140">
      <FadeIn data-id="element-141">
        <h2 className="text-2xl md:text-3xl font-bold text-[#2D2A26] mb-10 text-center" data-id="element-142">
          What you'll be able to say (honestly) after 14 days
        </h2>

        <div className="grid gap-6 mb-20" data-id="element-143">
          {quotes.map((quote, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-[#7B9E6B] flex gap-4" data-id="element-144">
              <Quote className="w-8 h-8 text-[#7B9E6B]/30 flex-shrink-0" data-id="element-145" />
              <p className="text-lg md:text-xl font-serif italic text-[#2D2A26]" data-id="element-146">
                {quote}
              </p>
            </div>)}
        </div>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-147">
        <h2 className="text-2xl md:text-3xl font-bold text-[#2D2A26] mb-10 text-center border-t border-[#FF5A5F]/15 pt-12" data-id="element-148">
          What's inside (exactly)
        </h2>

        <div className="grid gap-6" data-id="element-149">
          {contents.map((item, i) => <div key={i} className="flex items-start gap-4 p-4 rounded-lg hover:bg-white/50 transition-colors" data-id="element-150">
              <div className="bg-[#F5F2EB] p-3 rounded-full flex-shrink-0" data-id="element-151">
                <item.icon className="w-6 h-6 text-[#7B9E6B]" data-id="element-152" />
              </div>
              <div data-id="element-153">
                <h3 className="font-bold text-lg text-[#2D2A26]" data-id="element-154">
                  {item.title}
                </h3>
                <p className="text-[#2D2A26]/80" data-id="element-155">{item.desc}</p>
              </div>
            </div>)}
        </div>
      </FadeIn>
    </section>;
}